module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "",
      "size": "small"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.Mode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Mode", $$v)
      },
      expression: "filters.Mode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "All",
      "label": "全部"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "UnComplete",
      "label": "待入库"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Complete",
      "label": "完成"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Cancel",
      "label": "取消"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表",
      "size": "small",
      "disabled": !_vm.filters.IsAdmin
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.WID),
      callback: function($$v) {
        _vm.$set(_vm.filters, "WID", $$v)
      },
      expression: "filters.WID"
    }
  }, _vm._l((_vm.warehouses), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "货主",
      "size": "small"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.OwnerID),
      callback: function($$v) {
        _vm.$set(_vm.filters, "OwnerID", $$v)
      },
      expression: "filters.OwnerID"
    }
  }, _vm._l((_vm.ownerList), function(item) {
    return _c('el-option', {
      key: item.DataID,
      attrs: {
        "value": item.DataID,
        "label": item.Code + item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "单号/采购单号",
      "size": "small"
    },
    model: {
      value: (_vm.filters.KeyWord),
      callback: function($$v) {
        _vm.$set(_vm.filters, "KeyWord", $$v)
      },
      expression: "filters.KeyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    ref: "waybill",
    attrs: {
      "placeholder": "快递单号",
      "size": "small"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.filters.Waybill),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Waybill", $$v)
      },
      expression: "filters.Waybill"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name",
      "size": "small"
    },
    on: {
      "select": _vm.handleSelectSearch
    },
    model: {
      value: (_vm.autoKeyword),
      callback: function($$v) {
        _vm.autoKeyword = $$v
      },
      expression: "autoKeyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.stockInList,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "sortable": "",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "单号",
      "prop": "OrderID",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源单号",
      "prop": "ReferenceID",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "属性",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.Level !== '普通'),
            expression: "scope.row.Level!=='普通'"
          }],
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.Level)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.NewProduct !== '普通'),
            expression: "scope.row.NewProduct!=='普通'"
          }],
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.NewProduct)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.Types !== '普通' && scope.row.Types !== ''),
            expression: "scope.row.Types !=='普通' && scope.row.Types!==''"
          }],
          attrs: {
            "type": "info"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.Types)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Quantity) + " / " + _vm._s(scope.row.StockIn) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "待收数量",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Quantity) + " - " + _vm._s(scope.row.StockIn) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "Status",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("cutDate")(scope.row.Date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("设置")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "page-sizes": [20, 30, 50, 100],
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "1136px",
      "title": "入库单详情：",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "custom-class": "el-dialog--large",
      "top": "10%"
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('span', {
    staticClass: "dialog-title",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      入库单详情：" + _vm._s(_vm.editForm.OrderID) + "\n      "), _c('el-tag', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.Level !== '普通'),
      expression: "editForm.Level!=='普通'"
    }],
    attrs: {
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm._f("changePara")(_vm.editForm.Level)))]), _vm._v(" "), _c('el-tag', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.NewProduct !== '普通'),
      expression: "editForm.NewProduct!=='普通'"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm._f("changePara")(_vm.editForm.NewProduct)))]), _vm._v(" "), _c('el-tag', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.Types !== '普通' && _vm.editForm.Types !== ''),
      expression: "editForm.Types !=='普通' && editForm.Types!==''"
    }],
    attrs: {
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm._f("changePara")(_vm.editForm.Types)))])], 1), _vm._v(" "), _c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "入库单",
      "name": "入库单"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": [_vm.editForm],
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "单号",
      "prop": "OrderID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源单号",
      "width": "",
      "prop": "ReferenceID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "属性",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.Level !== '普通'),
            expression: "scope.row.Level!=='普通'"
          }],
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.Level)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.NewProduct !== '普通'),
            expression: "scope.row.NewProduct!=='普通'"
          }],
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.NewProduct)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.Types !== '普通' && scope.row.Types !== ''),
            expression: "scope.row.Types !=='普通' && scope.row.Types!==''"
          }],
          attrs: {
            "type": "info"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.Types)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计划数量",
      "prop": "Quantity",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已入数量",
      "prop": "Receive",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "Status",
      "width": ""
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [(_vm.editForm.hasOwnProperty('1688')) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "s1688-imgBox__list"
  }, _vm._l((_vm.editForm['1688']), function(imgItem, imgKey) {
    return _c('div', {
      key: imgKey,
      staticClass: "s1688-imgBox__list_item"
    }, [(!(_vm.dialogImgCollapse && imgKey > 7)) ? [_c('el-image', {
      staticClass: "s1688-imgBox__list_item-img",
      attrs: {
        "src": imgItem.ImgUrl,
        "fit": "contain"
      },
      on: {
        "click": function($event) {
          _vm.openPreview(imgItem)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "s1688-imgBox__list_item-text"
    }, [_c('span', [_vm._v(_vm._s(imgItem.Sku))]), _c('span', {
      staticClass: "ride"
    }, [_vm._v("x")]), _c('span', [_vm._v(_vm._s(imgItem.Quantity))])])] : _vm._e()], 2)
  })), _vm._v(" "), (_vm.editForm['1688'].length > 8) ? _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogImgCollapse = !_vm.dialogImgCollapse
      }
    }
  }, [_vm._v(_vm._s(_vm.dialogImgCollapse ? ("展开全部" + (_vm.editForm['1688'].length) + "张图片") : '折叠图片'))])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.editForm.ApplyProduct,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "产品图",
      "width": "83"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.Image && scope.row.Image !== '') ? _c('el-image', {
          staticClass: "product-thumbnail",
          attrs: {
            "src": scope.row.Image,
            "preview-src-list": [scope.row.Image]
          }
        }, [_c('div', {
          staticClass: "product-thumbnail__placeholder",
          attrs: {
            "slot": "placeholder"
          },
          slot: "placeholder"
        }, [_c('i', {
          staticClass: "el-icon-loading"
        }), _vm._v(" "), _c('span', [_vm._v("加载中...")])])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("[" + _vm._s(scope.row.Product.Status) + "] [" + _vm._s(scope.row.Product.FullSKU) + "] " + _vm._s(scope.row.Product.FullName) + " * " + _vm._s(scope.row.Product.Quantity))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包裹",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('cm-package-size', {
          attrs: {
            "package-data": scope
          },
          on: {
            "size-change": _vm.anewData
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计划数量",
      "prop": "Quantity",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已入数量",
      "prop": "Receive",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "本次入库",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "readonly": scope.row.Receive == scope.row.Quantity || !scope.row.BlnSkuComplete,
            "placeholder": scope.row.Receive == scope.row.Quantity ? '已完成' : ''
          },
          on: {
            "change": function($event) {
              _vm.reRealTime(scope.row, $event)
            }
          },
          model: {
            value: (scope.row.receiveNum),
            callback: function($$v) {
              _vm.$set(scope.row, "receiveNum", $$v)
            },
            expression: "scope.row.receiveNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "打印数量",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cell"
        }, [_c('div', {
          staticClass: "el-input el-input-group el-input-group--append"
        }, [_c('input', {
          staticClass: "el-input__inner",
          attrs: {
            "type": "text",
            "readonly": +scope.row.Receive <= 0 || !scope.row.BlnSkuComplete,
            "autocomplete": "off"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "el-input-group__append"
        }, [_c('button', {
          staticClass: "el-button el-button--default btn-pd",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.print(scope.row)
            }
          }
        }, [_c('span', [_vm._v("打印")])])])])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n            本次收货：" + _vm._s(_vm.receive.ReceiveCount) + "个，提交后本收货单的状态将变更为 " + _vm._s(_vm.receive.NewStatus) + "  \n            "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading,
      "disabled": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "入库单调整",
      "name": "入库单调整"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": [_vm.editForm],
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "单号",
      "prop": "OrderID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源单号",
      "width": "",
      "prop": "ReferenceID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "属性",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.Level !== '普通'),
            expression: "scope.row.Level!=='普通'"
          }],
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.Level)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.NewProduct !== '普通'),
            expression: "scope.row.NewProduct!=='普通'"
          }],
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.NewProduct)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.Types !== '普通' && scope.row.Types !== ''),
            expression: "scope.row.Types !=='普通' && scope.row.Types!==''"
          }],
          attrs: {
            "type": "info"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.Types)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计划数量",
      "prop": "Quantity",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已入数量",
      "prop": "Receive",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "Status",
      "width": ""
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.editForm.ApplyProduct,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "产品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("[" + _vm._s(scope.row.Product.Status) + "] [" + _vm._s(scope.row.Product.FullSKU) + "] " + _vm._s(scope.row.Product.FullName) + " * " + _vm._s(scope.row.Product.Quantity))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计划数量",
      "prop": "Quantity",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已入数量",
      "prop": "Receive",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "调整数量",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          on: {
            "change": _vm.adRealTime
          },
          model: {
            value: (scope.row.adjustNum),
            callback: function($$v) {
              _vm.$set(scope.row, "adjustNum", $$v)
            },
            expression: "scope.row.adjustNum"
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n            本次调整：" + _vm._s(_vm.receiveAdjust.ReceiveCount) + "个，提交后本收货单的状态将变更为 " + _vm._s(_vm.receiveAdjust.NewStatus) + "  \n            "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n              事由：\n              "), _c('el-select', {
    attrs: {
      "placeholder": "选择事由"
    },
    model: {
      value: (_vm.receiveAdjust.Subject),
      callback: function($$v) {
        _vm.$set(_vm.receiveAdjust, "Subject", $$v)
      },
      expression: "receiveAdjust.Subject"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "请选择"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "退回供应商",
      "label": "退回供应商"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "收货错误",
      "label": "收货错误"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "供应商发错数量",
      "label": "供应商发错数量"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading,
      "disabled": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.AdjustSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "入库流水",
      "name": "入库流水"
    }
  }, [(_vm.activeTab === '入库流水') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": [_vm.editForm],
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "单号",
      "prop": "OrderID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源单号",
      "width": "",
      "prop": "ReferenceID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "属性",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.Level !== '普通'),
            expression: "scope.row.Level!=='普通'"
          }],
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.Level)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.NewProduct !== '普通'),
            expression: "scope.row.NewProduct!=='普通'"
          }],
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.NewProduct)))]), _vm._v(" "), _c('el-tag', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.Types !== '普通' && scope.row.Types !== ''),
            expression: "scope.row.Types !=='普通' && scope.row.Types!==''"
          }],
          attrs: {
            "type": "info"
          }
        }, [_vm._v(_vm._s(_vm._f("changePara")(scope.row.Types)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "计划数量",
      "prop": "Quantity",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已入数量",
      "prop": "Receive",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "Status",
      "width": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.editForm.Flow,
      "highlight-current-row": "",
      "border": "",
      "max-height": "350"
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "时间",
      "prop": "",
      "width": "200",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Date))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包裹"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Stock.Package.FreightNo)), _c('br'), _vm._v(" " + _vm._s(scope.row.Stock.OrderID))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.Stock.Package.Product), function(p) {
          return _c('p', {
            key: p.DataID
          }, [_vm._v("[" + _vm._s(p.Product.Status) + "] [" + _vm._s(p.Product.FullName) + "] " + _vm._s(p.Product.FullSKU) + " * " + _vm._s(p.Product.Quantity))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作数量",
      "prop": "Quantity",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "prop": "TrueName",
      "width": "80"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "日志",
      "name": "日志"
    }
  }, [(_vm.activeTab === '日志') ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.editForm.Log,
      "highlight-current-row": "",
      "border": "",
      "max-height": "400"
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作人",
      "prop": "Name",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作记录",
      "prop": "Remark"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "prop": "",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm._f("cutDate")(scope.row.Date)))])]
      }
    }])
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewShow),
      expression: "previewShow"
    }],
    staticClass: "preview"
  }, [_c('div', {
    staticClass: "preview-close",
    on: {
      "click": function($event) {
        _vm.previewShow = false
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-img"
  }, [_c('div', {
    staticClass: "preview-img_img-box"
  }, [_c('div', {
    staticClass: "preview-img_img-box_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.previewImg.url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-img_img-box_info"
  }, [_c('span', [_vm._v(_vm._s(_vm.previewImg.sku) + " * " + _vm._s(_vm.previewImg.quantity))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-319acbee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/stockIn/stockInList.vue
// module id = 834
// module chunks = 1